import * as actionTypes from './actionTypes';
import axios from 'axios';

export const submitOrderStart = ( ) => {
    return {
        type: actionTypes.SUBMIT_ORDER_START,
    }
}
export const submitOrderInit = ( ) => {
    return {
        type: actionTypes.SUBMIT_ORDER_INIT,
    }
}
export const submitOrderSuccess = ( orderData ) => {
    return {
        type: actionTypes.SUBMIT_ORDER_SUCCESS,
        submittedOrder: orderData,
    }
}
export const submitOrderFailed = ( errorMessage ) => {
    return {
        type: actionTypes.SUBMIT_ORDER_FAILED,
        error: errorMessage,
    }   
}

export const submitOrder = ( userData, token ) => {
    return dispatch => {
        dispatch( submitOrderStart() );
        console.log('excuted');
        axios.post(`https://color-shop-c3776-default-rtdb.firebaseio.com/orders.json?auth${token}`, userData)
            .then( res => {
                const orderDate = { orderId: res.data.name, ...userData };
                dispatch( submitOrderSuccess( orderDate ) )
            })
            .catch( err => {
                dispatch( submitOrderFailed( err.message  ) )
            } )
    }
}


export const fetcOrderstStart = (  ) => {
    return {
        type: actionTypes.FETCH_ORDERS_START,
    }
}
export const fetchOrdersSuccess = ( ordersData ) => {
    return {
        type: actionTypes.FETCH_ORDERS_SUCCESS,
        orders: ordersData,
    }
}
export const fetchOrdersFailed = ( errorMessage ) => {
    return {
        type: actionTypes.FETCH_ORDERS_FAILED,
        error: errorMessage,
    }
}
export const fetchOrders = (  ) => {
    return dispatch => {
        dispatch( fetcOrderstStart( ) );
        axios.get('https://color-shop-c3776-default-rtdb.firebaseio.com/orders.json')
                .then( response => {
                    let fetchedOrders = [ ];
                    for ( let order in response.data ) {
                        let loadedOrder = { orderId: order ,  ...response.data[order]  }
                        fetchedOrders.push(loadedOrder);
                    }
                    dispatch( fetchOrdersSuccess( fetchedOrders ) );
                })
                .catch( err => {
                    dispatch( fetchOrdersFailed( err.message  ) );
                } )
            }
}